export default __webpack_public_path__ + "static/media/tooth.62345650.svg";